import NotificationCard from "./NotificationCard";

export default function ImageNotificationCard(props) {
    return (
        <NotificationCard
            {...props}
            type="image"
            destination={"/image/" + props.notification.file}
            mediaUrl={props.notification.url}
            mediaAlt={props.notification.title || "Shared image"}
            showComments
        />
    );
}
